import { Link } from "react-router-dom";
import { dramaInfo } from "@/mocks/drama";

export default function DramaOverview() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-6 md:gap-10">
        <div className="w-full max-w-[300px] mx-auto lg:mx-0">
          <div className="relative w-full aspect-[3/4] rounded-lg overflow-hidden border border-background-200 bg-background-200">
            <img
              src={dramaInfo.cover}
              alt="善良的小姨子 剧集海报"
              title="善良的小姨子 高清剧集海报"
              className="w-full h-full object-cover object-top"
            />
            <span className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/90 to-transparent px-4 py-4 flex items-center justify-between">
              <span className="text-background-50 text-xs flex items-center gap-1.5">
                <i className="ri-tv-2-line"></i> 更新至 {dramaInfo.updatedEpisodes} 集
              </span>
              <span className="text-secondary-400 text-xs font-bold flex items-center gap-1">
                <i className="ri-star-fill"></i> {dramaInfo.rating}
              </span>
            </span>
          </div>
        </div>

        <div className="flex flex-col">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-600 mb-2">
            <span className="w-4 h-0.5 bg-accent-500"></span>
            剧集概览
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{dramaInfo.title}</h2>
          <p className="text-accent-600 text-sm mt-2 font-medium">{dramaInfo.tagline}</p>

          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mt-4 text-sm text-foreground-600">
            <span>{dramaInfo.year}</span>
            <span>{dramaInfo.region}</span>
            <span>{dramaInfo.genre}</span>
            <span className="text-primary-600 font-medium">共 {dramaInfo.totalEpisodes} 集</span>
            <span className="px-2 py-0.5 rounded bg-primary-50 text-primary-700 text-xs">{dramaInfo.status}</span>
          </div>

          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mt-5">{dramaInfo.synopsis}</p>

          <div className="flex flex-wrap gap-2 mt-5">
            {dramaInfo.tags.map((tag) => (
              <span key={tag} className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 text-xs">
                {tag}
              </span>
            ))}
          </div>

          <div className="grid grid-cols-3 gap-3 mt-6 max-w-md">
            <div className="rounded-lg bg-background-100 border border-background-200 px-3 py-3 text-center">
              <div className="font-heading text-xl font-bold text-primary-600">{dramaInfo.totalEpisodes}</div>
              <div className="text-xs text-foreground-500 mt-1">总集数</div>
            </div>
            <div className="rounded-lg bg-background-100 border border-background-200 px-3 py-3 text-center">
              <div className="font-heading text-xl font-bold text-accent-600">{dramaInfo.updatedEpisodes}</div>
              <div className="text-xs text-foreground-500 mt-1">已更新</div>
            </div>
            <div className="rounded-lg bg-background-100 border border-background-200 px-3 py-3 text-center">
              <div className="font-heading text-xl font-bold text-secondary-700">{dramaInfo.rating}</div>
              <div className="text-xs text-foreground-500 mt-1">观众评分</div>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-3 mt-7">
            <Link
              to={`/play/${dramaInfo.updatedEpisodes}`}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-fill text-lg"></i>
              立即观看 第{dramaInfo.updatedEpisodes}集
            </Link>
            <Link
              to="/detail"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-100 border border-background-300 text-foreground-800 text-sm md:text-base font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-book-open-line text-lg"></i>
              剧情详情
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}